// Mapeia o turno cadastrado (matrícula/turma) — texto livre, tipo "Manhã",
// "TARDE", "tarde " — pro `periodo` normalizado ('manha'/'tarde'/'noite')
// gravado em `presenca.periodo` (ver backend/migrate-add-periodo-presenca.js).
//
// Usada por QUALQUER tela que grava presença (POST /api/presenca), de
// propósito sempre a MESMA função — um lugar que gravasse com periodo=null
// por engano (turno não reconhecido, ou o campo simplesmente esquecido no
// payload) criaria uma linha NOVA a cada clique em vez de atualizar a
// existente: a chave única de `presenca` inclui `periodo`, e o MySQL nunca
// considera dois NULLs iguais entre si (nem um NULL igual a 'tarde'), então
// `ON DUPLICATE KEY UPDATE` simplesmente não dispara — foi exatamente o bug
// encontrado no botão de presença rápida da Grade (Grade.js), que não
// mandava `periodo` nenhum e duplicava a linha de presença do aluno a cada
// clique.
export function turnoParaPeriodo(turno) {
  const t = String(turno || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim();
  if (t.includes('manh')) return 'manha';
  if (t.includes('tard')) return 'tarde';
  if (t.includes('noit')) return 'noite';
  return null;
}
